module.exports = __webpack_public_path__ + "static/media/library-goal.2a79a13a.svg";